import React, { useState } from 'react';
import Layout from '../../components/Layout';
import Card from '../../ui/Card/Card';
import Tabs from '../../ui/Tabs/Tabs';
import Icon from '../../ui/Icon';
import { ICONS } from '../../ui/icon-map';
import { ArchiveSearch } from '../DailyBookingManagement/components/ArchiveSearch';
import { ArchiveMultiSearch } from '../DailyBookingManagement/components/ArchiveMultiSearch';
import { usePermissions } from '../../hooks/usePermissions';
import { PERMISSIONS } from '../../constants/permissions';
import { useSearchParams } from 'react-router-dom';
import MultiCarAnalysis from '../MultiCar/Multi-Car-Analysis';


const TABS = [
    { id: 'single', label: 'Archive Search', glyph: ICONS.search, permission: PERMISSIONS.history_tab_single },
    { id: 'multi', label: 'Contract Timeline', glyph: ICONS.calendar, permission: PERMISSIONS.history_tab_multi },
    // its own permission since permissions phase 4 (4 Oct 2026; it followed analyze_contracts_multicar until the upgrade)
    { id: 'multicar', label: 'Multi-car', glyph: ICONS.multi_car, permission: 'history_tab_multicar' },
    // User Activity moved to Administration > Activity log, the Admin role only (owner, 20 Oct 2026)
];

const HistoryLens = () => {
    const { hasPermission } = usePermissions();
    const [params, setParams] = useSearchParams();
    const allowed = TABS.filter(tab => hasPermission(tab.permission));
    // ?tab=multicar opens a tab directly (the old /multi-car page lands here); else the first allowed one
    const asked = params.get('tab');
    const [pickedTab, setActiveTabState] = useState(allowed.some(t => t.id === asked) ? asked : (allowed[0]?.id || 'single'));
    // only a tab the user holds shows its panel (a role with none of them sees none - was the Archive Search)
    const activeTab = allowed.some(t => t.id === pickedTab) ? pickedTab : allowed[0]?.id;
    const setActiveTab = (id) => { setActiveTabState(id); setParams(id === 'single' ? {} : { tab: id }, { replace: true }); };

    const tabItems = allowed.map(tab => ({ id: tab.id, label: tab.label, icon: <Icon glyph={tab.glyph} size="sm" /> }));

    return (
        <Layout title="History Lens" subtitle="Access historical data and generated reports">
            {/* full width: the timeline shows every column without a sideways scrollbar */}
            <div className="w-full space-y-4">

                <Tabs
                    items={tabItems}
                    value={activeTab}
                    onChange={setActiveTab}
                    label="History sections"
                    idPrefix="history-tab"
                />

                <div role="tabpanel" id={`history-tab-panel-${activeTab}`} aria-labelledby={`history-tab-${activeTab}`}>
                    {/* Archive Search Section */}
                    {activeTab === 'single' && (
                        <Card title="Archive Search">
                            <ArchiveSearch />
                        </Card>
                    )}

                    {/* Archive Multi-Search Section */}
                    {activeTab === 'multi' && (
                        <Card
                            padding="sm"
                            title="Contract Timeline"
                            subtitle="Search for contracts and view their opening and closing dates with timeline information."
                        >
                            <ArchiveMultiSearch />
                        </Card>
                    )}

                    {/* Multi-car: contracts where the customer changed car */}
                    {activeTab === 'multicar' && <MultiCarAnalysis embedded />}
                </div>

            </div>
        </Layout>
    );
};

export default HistoryLens;
